import { Component, Vue, Watch } from 'vue-property-decorator';
import ExpiryTimer from '@/components/cart/ExpiryTimer.vue';
import { TixTime } from '@/TixTime/TixTime';
import { API } from '@/api/API';
import { fetchOwnCart } from '@/api/Cart';
import { apiErrorMessage, logInTrackJS } from '@/errors/helpers';
import { cartExpiresIn, shouldAlertAboutCartExpiry } from '@/state/Cart';
import store from '@/store/store';
@Component({ name: 'ExtendCartTimerModal', components: { ExpiryTimer } })
export default class default_1 extends Vue {
    expiresIn = null;
    expiryInterval;
    error = null;
    t;
    submitting = false;
    created() {
        this.setExpiry();
        this.expiryInterval = setInterval(this.setExpiry, 1000);
    }
    destroyed() {
        clearInterval(this.expiryInterval);
    }
    get localExpiry() {
        return store.getters['Cart/localExpiry'];
    }
    get declinedCartTimerExtension() {
        return store.getters['Cart/declinedCartTimerExtension'];
    }
    @Watch('declinedCartTimerExtension')
    @Watch('localExpiry', { immediate: true })
    handleAutoCloseOnCartChange() {
        if (!shouldAlertAboutCartExpiry()) {
            this.close();
        }
    }
    setExpiry() {
        this.expiresIn = cartExpiresIn();
    }
    close() {
        this.$modals.close({ name: 'extend-cart-timer-modal' });
    }
    dismiss() {
        store.commit('Cart/declinedCartTimerExtension', true);
    }
    confirm() {
        const cart = store.getters['Cart/cart'];
        const extended = new TixTime(cart?.expires_at).add(2, 'minutes');
        this.submitting = true;
        return API.patch(`my/cart/${cart.id}`, {
            body: {
                expires_at: extended.format(),
            },
        })
            .then((response) => {
            const localExpiry = new TixTime().add(response.expires_in - 5, 'seconds').asTimeValue();
            // The response from PATCH request does not contain the full CartApiResponse,
            // so we need a fetch here.
            return fetchOwnCart(cart.id).then((response) => {
                // It's too late by now and the cart has already expired.
                // This can happen when a user attempts to extend the cart timer on a slow connection and
                // when the cart almost expires
                if (this.$root.expiryModalOpen)
                    return;
                store.commit('Cart/localExpiry', localExpiry);
                store.commit('Cart/apiResponse', response);
            });
        })
            .catch((err) => {
            this.error = apiErrorMessage(err);
            logInTrackJS(this.error, { cartId: cart?.id });
        })
            .finally(() => {
            this.submitting = false;
        });
    }
}
